'use client'
import { Product } from "lib/shopify/types";
import { Gallery } from "./gallery";
import { useProduct } from "./product-context";

export function GalleryWrapper({ product }: { product: Product }) {
    const { state } = useProduct();
    const selectedVariant = state.color ? product.variants.find((variant) => variant.selectedOptions[0]?.value === state.color) : null
    const images = selectedVariant?.images?.references
    const edgelessImages = images ? images.edges.map((image) => image.node.image) : product.images.slice(0,20).map((image) => {return{src: image.url, altText: image.altText}})

    return (
        <Gallery
            images={edgelessImages.map((image) => ({
                src: image.src ,
                altText: image.altText
            }))}
        />
    );
}